import { Injectable } from '@angular/core';
import { PersonalSelectModel } from '../../models/personal/personal-select.model';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { PersonalApiModel } from '../../models/personal/person-api.model';
import { Observable } from 'rxjs';
import { TaskResultGeneric } from '../../models/task-result-generic';
import {
  InitialPasswordModel,
  InitialPasswordParameter,
} from '../../models/password/initial-password.model';
import {
  PersonalDefaultWorkModel,
  TaskResult,
} from '../../models/client-models';
import {
  EmailMessageModel,
  PersonalAuthorization,
} from '../../models/client-models';

const AUTH_ENDPOINT = 'authentication';
const PERSONAL_ENDPOINT = 'personal';

@Injectable({
  providedIn: 'root',
})
export class PersonalBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get personal list for selection help in login screen.
   *
   * @param filterValue entered value of user.
   */
  public getPersonalSelectList(filterValue: string) {
    return this.http.get<PersonalSelectModel[]>(
      AppConfig.settings.backend.url +
        AUTH_ENDPOINT +
        '/users' +
        '?filterValue=' +
        filterValue
    );
  }

  /**
   * Get authorization of person.
   *
   * @param personID.
   */
  public getPersonAuthorization(personID: number) {
    return this.http.get<PersonalAuthorization>(
      AppConfig.settings.backend.url +
        PERSONAL_ENDPOINT +
        '/authorization?personID=' +
        personID
    );
  }

  /**
   * Get default work info (order and cost center) for person.
   *
   * @param personID
   */
  public getDefaultWorkInfo(personID: number) {
    return this.http.get<PersonalDefaultWorkModel>(
      AppConfig.settings.backend.url +
        PERSONAL_ENDPOINT +
        '/defaults?personID=' +
        personID
    );
  }

  public savePersonalData(
    updatePerson: PersonalApiModel
  ): Observable<TaskResultGeneric<PersonalApiModel>> {
    return this.http.put<TaskResultGeneric<PersonalApiModel>>(
      AppConfig.settings.backend.url + PERSONAL_ENDPOINT,
      updatePerson
    );
  }

  public savePersonalOptions(
    updatePerson: PersonalApiModel
  ): Observable<TaskResultGeneric<PersonalApiModel>> {
    return this.http.put<TaskResultGeneric<PersonalApiModel>>(
      AppConfig.settings.backend.url + PERSONAL_ENDPOINT + '/options',
      updatePerson
    );
  }

  public setPersonalEmail(
    message: EmailMessageModel
  ): Observable<TaskResultGeneric<PersonalApiModel>> {
    return this.http.post<TaskResultGeneric<PersonalApiModel>>(
      AppConfig.settings.backend.url + PERSONAL_ENDPOINT + '/emailMessage',
      message
    );
  }

  public deletePersonalEmail(
    idPerson: number
  ): Observable<TaskResultGeneric<PersonalApiModel>> {
    return this.http.delete<TaskResultGeneric<PersonalApiModel>>(
      AppConfig.settings.backend.url +
        PERSONAL_ENDPOINT +
        '/emailMessage/' +
        idPerson
    );
  }

  public setInitialPassword(data: InitialPasswordParameter) {
    return this.http.post<TaskResultGeneric<InitialPasswordModel>>(
      AppConfig.settings.backend.url + PERSONAL_ENDPOINT + '/initialPassword',
      data
    );
  }

  public deletePassword(id: number) {
    return this.http.delete<TaskResult>(
      AppConfig.settings.backend.url + PERSONAL_ENDPOINT + '/password/' + id
    );
  }
}
